/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelVoucherCittadinoDTO } from '../model/models';
import { PagedModelVoucherEsercenteDTO } from '../model/models';
import { VoucherCittadinoDTO } from '../model/models';
import { VoucherCittadinoListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DettaglioMioVoucherRequestParams {
    idVoucher: string;
}

export interface DownloadMioVoucherPdfRequestParams {
    idVoucher: string;
}

export interface ElencoEsercentiMioVoucherRequestParams {
    idVoucher: string;
    pageable: Pageable;
}

export interface ListaMieiVoucherRequestParams {
    filter: VoucherCittadinoListFilter;
    pageable: Pageable;
}


export interface CittadinoVoucherControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Dettaglio di un proprio voucher (owner-check; 404 se non del caller)
     * 
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}
* @param requestParameters
     */
    dettaglioMioVoucher(requestParameters: DettaglioMioVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherCittadinoDTO>;

    /**
     * Download del PDF+QR di un proprio voucher (owner-check; 404 se non del caller)
     * 
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}/pdf
* @param requestParameters
     */
    downloadMioVoucherPdf(requestParameters: DownloadMioVoucherPdfRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Elenco paginato degli esercenti abilitati per un proprio voucher (owner-check; 404 se non del caller, flag spento, voucher non spendibile o scaduto)
     * 
     * @endpoint get /api/v1/cittadino/voucher/{idVoucher}/esercenti
* @param requestParameters
     */
    elencoEsercentiMioVoucher(requestParameters: ElencoEsercentiMioVoucherRequestParams, extraHttpRequestParams?: any): Observable<PagedModelVoucherEsercenteDTO>;

    /**
     * Lista paginata dei voucher del cittadino (self-scoped; include gli scaduti col flag)
     * 
     * @endpoint get /api/v1/cittadino/voucher
* @param requestParameters
     */
    listaMieiVoucher(requestParameters: ListaMieiVoucherRequestParams, extraHttpRequestParams?: any): Observable<PagedModelVoucherCittadinoDTO>;

}
